import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MapContainer, TileLayer, Polyline, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Route, Clock, MapPin } from "lucide-react";
import axios from "axios";
import { API } from "../lib/api";

/* Public trip story — token-protected route map (traveler-approved points only). */
export default function GuardianStory() {
  const { token } = useParams();
  const [story, setStory] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${API}/guardian/story/${token}`)
      .then((r) => { setStory(r.data); document.title = `${r.data.title} — TravelerPulse Trip Story`; })
      .catch(() => setErr("This trip story was not found or has been removed."));
  }, [token]);

  if (err) return <div className="max-w-lg mx-auto px-5 py-20 text-center text-sm text-zinc-500" data-testid="guardian-story-error">{err}</div>;
  if (!story) return <div className="max-w-lg mx-auto px-5 py-20 text-center text-sm text-zinc-400">Loading trip story…</div>;

  const pts = story.route.map((p) => [p.lat, p.lon]);
  const center = pts[Math.floor(pts.length / 2)];

  return (
    <div className="max-w-3xl mx-auto px-5 py-8" data-testid="guardian-story-page">
      <h1 className="font-heading font-900 text-2xl sm:text-3xl tracking-tight">{story.title}</h1>
      <p className="mt-1 text-xs text-zinc-500">by {story.traveler_name} · {new Date(story.started_at).toLocaleDateString()} → {new Date(story.ended_at).toLocaleDateString()}</p>
      <div className="mt-3 flex flex-wrap gap-4 text-xs text-zinc-600">
        <span className="inline-flex items-center gap-1"><Route className="w-3.5 h-3.5 text-blue-600" /> <b>{story.distance_km} km</b> traveled</span>
        <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5 text-emerald-600" /> <b>{story.route.length}</b> points ({story.precision} precision)</span>
        <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-violet-600" /> shared {new Date(story.created_at).toLocaleDateString()}</span>
      </div>
      <div className="mt-4 rounded-2xl overflow-hidden border border-zinc-200" style={{ height: 420 }} data-testid="guardian-story-map">
        <MapContainer center={center} zoom={pts.length > 1 ? 8 : 11} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
          <Polyline positions={pts} pathOptions={{ color: "#2563eb", weight: 4 }} />
          <CircleMarker center={pts[0]} radius={8} pathOptions={{ color: "#059669", fillOpacity: 0.8 }}><Popup>Start</Popup></CircleMarker>
          <CircleMarker center={pts[pts.length - 1]} radius={8} pathOptions={{ color: "#e11d48", fillOpacity: 0.8 }}><Popup>End</Popup></CircleMarker>
        </MapContainer>
      </div>
      <p className="mt-4 text-xs text-zinc-400">{story.attribution} — <Link to="/" className="text-blue-700 font-700 hover:underline">plan and share your own journeys on TravelerPulse.pro</Link></p>
    </div>
  );
}
